import { Injectable } from '@angular/core';
import { Settings } from '../../core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class EReqSmStorage {

    public sampleManagementUrl = `${this.settings.apiUrl}/ereq/sampleregistration`;

    constructor(
        private settings: Settings,
        private http: HttpClient) {
    }

    public getAccessionDetails(accessionNumber: string): Observable<any> {
        return this.http.get(`${this.sampleManagementUrl}/${accessionNumber}`);
    }

    public saveAccessionDetails(accession: string): Observable<any> {
        return this.http.post(`${this.sampleManagementUrl}/savevisitdetailsereq`, { accessionNumber: accession }, { observe: 'response' })
            .pipe(map((response) => {
                return response.status;
            })
        );
    }
}